const place_model = {
    children: [],
    parents: [],
    name: null,
    name_real: null,
    region: null,
    region_real: null,
    search_text: null,
    country: null,
    type: null,
    timezone: null,
    hits: null,
    priority: null,
    custom: null,
    meta: {
        languages: [],
        currency: '',
        timezone: '',
        visas: null,
        money: null,
        mobile_phones: null,
        websites: null,
        important_numbers: null,
        opening_hours: null,
        arriving: null,
        getting_around: null,
        working_hours: [
            {
                day: "Luni",
                start: null,
                end: null,
                open: false
            },
            {
                day: "Marti",
                start: null,
                end: null,
                open: false
            },
            {
                day: "Miercuri",
                start: null,
                end: null,
                open: false
            },
            {
                day: "Joi",
                start: null,
                end: null,
                open: false
            },
            {
                day: "Vineri",
                start: null,
                end: null,
                open: false
            },
            {
                day: "Sambata",
                start: null,
                end: null,
                open: false
            },
            {
                day: "Duminica",
                start: null,
                end: null,
                open: false
            },
        ],
        contact: null,
        weather: [
            {
                month: "January",
                high: null,
                medium: null,
                low: null,
                weather: null
            },
            {
                month: "February",
                high: null,
                medium: null,
                low: null,
                weather: null
            },
            {
                month: "March",
                high: null,
                medium: null,
                low: null,
                weather: null
            },
            {
                month: "April",
                high: null,
                medium: null,
                low: null,
                weather: null
            },
            {
                month: "May",
                high: null,
                medium: null,
                low: null,
                weather: null
            },
            {
                month: "June",
                high: null,
                medium: null,
                low: null,
                weather: null
            },
            {
                month: "July",
                high: null,
                medium: null,
                low: null,
                weather: null
            },
            {
                month: "August",
                high: null,
                medium: null,
                low: null,
                weather: null
            },
            {
                month: "September",
                high: null,
                medium: null,
                low: null,
                weather: null
            },
            {
                month: "October",
                high: null,
                medium: null,
                low: null,
                weather: null
            },
            {
                month: "November",
                high: null,
                medium: null,
                low: null,
                weather: null
            },
            {
                month: "December",
                high: null,
                medium: null,
                low: null,
                weather: null
            }
        ],
        daily_costs: [
            {
                type: "Budget",
                min: null,
                max: null,
                money: null,
                description: null
            },
            {
                type: "Midrange",
                min: null,
                max: null,
                money: null,
                description: null
            },
            {
                type: "Luxury",
                min: null,
                max: null,
                money: null,
                description: null
            },
        ],
        when_to_go: [
            {
                type: "High Season",
                start_date: null,
                end_date: null,
                description: null
            },
            {
                type: "Low Season",
                start_date: null,
                end_date: null,
                description: null
            },
            {
                type: "Overall",
                start_date: null,
                end_date: null,
                description: null
            },
        ]
    },
    geometry: {
        location: {
            lat: 44.439663,
            lng: 26.096306
        },
        viewport: {
            northeast: {
                lat: 44.541407,
                lng: 26.225574999999935
            },
            southwest: {
                lat: 44.3342445,
                lng: 25.963700099999983
            }
        }
    }/*, todo remove once the multiselects work
    parents: null,
    children: null*/
};

const rating_model = {
    resource_owner: "",
    resource_type: "",
    resource_id: "",
    rating: 0,
    id: ""
};

const article_model = {
    place: {
        id: null,
        name: null
    },
    place_id: null,
    user: {
        id: "",
        name: "",
        email: ""
    },
    user_id: null,
    section_id: null,
    title: null,
    body: null,
    status: 'pending',
    language: 'en',
    order: 50
};

const comment_model = {
    author: {
        avatar: "",
        id: "",
        name: ""
    },
    body: null,
    created_at: "",
    resource_id: "",
    resource_owner: "",
    resource_type: "",
    status: "pending"
};

const photo_model = {
    place: {
        id: "",
        name: "",
        type: ""
    },
    place_id: "",
    user: {
        id: "",
        name: "",
        email: ""
    },
    user_id: "",
    section_id: "",
    section: {
        id: "",
        name: "",
        slug: ""
    },
    comment_sum: "",
    description: "",
    title: "",
    body: "",
    status: '',
    url: '',
};

const static_page_model = {
    slug: null,
    platform: {},
    meta:[],
    translations: {
        title: {
            ro: null,
            en: null
        },
        body: {
            ro: null,
            en: null
        },
        html_meta: {
            ro: [],
            en: []
        },
        html_title: {
            ro: null,
            en: null
        },
        url_slug: {
            ro: [],
            en: []
        },
    }
};

export default {
    'place_item': place_model,
    'article_item': article_model,
    'rating_item': rating_model,
    'comment_item': comment_model,
    'photo_item': photo_model,
    'static_page_item': static_page_model
};
